import { SystemStyleObject } from '@chakra-ui/styled-system';
import { BadgeColorScheme, BadgeProps } from './Badge';

const baseStyle: SystemStyleObject = {
  borderRadius: '4',
  display: 'inline-flex',
  gap: '4',
  padding: '4',
  textStyle: 'comp/badge/sm',
};

type ColorsType = Record<'bold' | 'subtle', Record<BadgeColorScheme, Record<'color' | 'backgroundColor', string>>>;

const colors: ColorsType = {
  subtle: {
    progress: {
      backgroundColor: 'sys/interactive/subtle',
      color: 'sys/interactive/strong',
    },
    neutral: {
      backgroundColor: 'sys/neutral/subtle',
      color: 'sys/neutral/strong',
    },
    info: {
      backgroundColor: 'sys/info/subtle',
      color: 'sys/info/strong',
    },
    positive: {
      backgroundColor: 'sys/success/subtle',
      color: 'sys/success/strong',
    },
    negative: {
      backgroundColor: 'sys/critical/subtle',
      color: 'sys/critical/strong',
    },
    warning: {
      backgroundColor: 'sys/warning/subtle',
      color: 'sys/warning/strong',
    },
    orange: {
      backgroundColor: 'sys/orange/subtle',
      color: 'sys/orange/strong',
    },
    turquoise: {
      backgroundColor: 'sys/turquoise/subtle',
      color: 'sys/turquoise/strong',
    },
  },
  bold: {
    progress: {
      backgroundColor: 'sys/interactive/bold',
      color: 'text/on-color',
    },
    neutral: {
      backgroundColor: 'sys/neutral/bold',
      color: 'text/on-color',
    },
    info: {
      backgroundColor: 'sys/info/bold',
      color: 'text/on-color',
    },
    positive: {
      backgroundColor: 'sys/success/bold',
      color: 'text/on-color',
    },
    negative: {
      backgroundColor: 'sys/critical/bold',
      color: 'text/on-color',
    },
    warning: {
      backgroundColor: 'sys/warning/muted',
      color: 'text/primary',
    },
    orange: {
      backgroundColor: 'sys/orange/bold',
      color: 'text/on-color',
    },
    turquoise: {
      backgroundColor: 'sys/turquoise/bold',
      color: 'text/on-color',
    },
  },
};

const getVariant = (props: BadgeProps) => {
  const { colorScheme, variant } = props;
  return colors[variant || 'subtle'][colorScheme || 'neutral'];
};

const BadgeTheme = {
  baseStyle,
  variants: {
    bold: getVariant,
    subtle: getVariant,
  },
  defaultProps: {
    variant: 'subtle',
    colorScheme: 'neutral',
  },
};

export default BadgeTheme;
